import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileDropdownComponent } from './components/profile-dropdown/profile-dropdown.component';
import { AngularCommonModuleConfig } from './model/AngularCommonModuleConfig';
import { AngularCommonService } from './service/angular-common.service';
import { SpinnerInterceptor } from './service/spinner.interceptor';
import { CustomTooltipDirective } from './directive/custom-tooltip.directive';
import { SecuritySettingsComponent } from './components/security-settings/security-settings.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { ProgressSpinnerService } from './service/progress-spinner.service';
import { TokenExpiredInterceptor } from './service/token-expired.interceptor';
import { MfaSettingsCognitoComponent } from './components/mfa-settings-cognito/mfa-settings-cognito.component';
import { MfaSettingsModule } from '@baxter-jenkins/mfa-settings';

@NgModule({
  declarations: [
    ProfileDropdownComponent,
    CustomTooltipDirective,
    SecuritySettingsComponent,
    MfaSettingsCognitoComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    QRCodeModule,
    MfaSettingsModule
  ],
  exports: [
    ProfileDropdownComponent,
    SecuritySettingsComponent,
    CustomTooltipDirective
  ],
  providers: [
    SpinnerInterceptor,
    AngularCommonService,
    ProgressSpinnerService,
    TokenExpiredInterceptor
  ]
})
export class AngularCommonModule {
  static forRoot(config: AngularCommonModuleConfig): ModuleWithProviders<AngularCommonModule> {
    AngularCommonService.config = config;
    return {
      ngModule: AngularCommonModule
    };
  }
}
